/*
---
covers:
  - frontend/src/pages/inci/aliados/partner-panel.tsx
  - frontend/src/hooks/inci/aliados/use-partner-panel.ts
  - frontend/src/hooks/platform/use-view-as-partner.tsx
  - backend/app/inci/aliados/routers/partner_panel.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'tu-panel',
  titulo: 'Tu panel',
  resumen:
    'El panel del partner (consultor SST externo): tus empresas cliente, tu cupo, tus «Pendientes de aprobación» (registros bajo tu código a la espera de aprobar o rechazar) y tu bitácora, con acceso directo a operar el SG-SST de cada una.',
  enCorto: [
    'Sus empresas cliente, su cupo y cartera',
    'Apruebe pendientes y entre a operar',
    'El SG-SST de cada una, adentro',
  ],
  replayId: 'tu-panel',
  operaciones: [
    {
      id: 'ver-cupo',
      titulo: 'Ver tu cupo de empresas por segmento',
      como: 'Al entrar a «Panel del partner» (link «Panel del partner» en el menú lateral), arriba de todo aparecen cuántas empresas «Usadas» tienes contra tu cupo total —con una barra que muestra cuánto margen queda— y cuántas te quedan «Disponibles»; debajo, la tarjeta «Cuota por segmento» abre la matriz por tamaño × clase de riesgo con el detalle de cada celda.',
      porQueImporta:
        'Tu cupo determina cuántas empresas puedes traer en plan pagado bajo tu código antes de que una nueva quede «sin cupo» — verlo de una vez te evita ofrecer un cupo que ya no tienes.',
    },
    {
      id: 'aprobar-pendientes',
      titulo: 'Aprobar o rechazar una empresa pendiente',
      como: 'La sección «Pendientes de aprobación» lista las empresas que se registraron con tu código mientras tu cupo del segmento alcanzaba. Cada fila tiene «Aprobar» (un clic) y «Rechazar» (abre un cuadro de confirmación, porque desvincula a la empresa de tu cartera).',
      porQueImporta:
        'Ninguna empresa entra a tu cartera pagada sin tu decisión explícita — el registro bajo tu código solo la deja «pendiente»; tú confirmas si de verdad es tu cliente antes de que cuente contra tu cupo.',
    },
    {
      id: 'revisar-cartera',
      titulo: 'Revisar tu cartera de empresas',
      como: 'La sección «Empresas» lista todas tus empresas cliente con su plan, su banda de cumplimiento y su estado de pago; el buscador filtra por nombre, y cada fila lleva directo al SG-SST de esa empresa al hacer clic.',
      porQueImporta:
        'Es tu vista consolidada de cómo va cada cliente en su SG-SST y en sus pagos, sin tener que entrar empresa por empresa a revisar.',
    },
    {
      id: 'consultar-pagos',
      titulo: 'Consultar tus facturas y tu ciclo de facturación',
      como: 'La sección «Pagos» lista tus facturas (número, empresa, estado, fecha, total) con un link «Pagar» cuando aplica; arriba puedes alternar tu ciclo preferido entre «Mensual» y «Anual» — solo rige las suscripciones nuevas, no las que ya están abiertas.',
      porQueImporta:
        'Tener tus facturas y tu preferencia de ciclo en un solo lugar te evita perseguir cada cobro empresa por empresa.',
    },
  ],
}
